define.alias("shared/helpers/uuid", "calendar/helpers/uuid");